import angular from 'angular';
import {
  authorizationService,
  appVersionService
} from 'app/services';
import authorizationInterceptor from './authorization.interceptor';
import appVersionInterceptor from './appVersion.interceptor';


export default angular.module('app.interceptors', [
  authorizationService,
  appVersionService,
])
  .service('authorizationInterceptor', authorizationInterceptor)
  .factory('appVersionInterceptor', appVersionInterceptor)
  .config(['$httpProvider', ($httpProvider) => {
    $httpProvider.interceptors.push('authorizationInterceptor');
    $httpProvider.interceptors.push('appVersionInterceptor');
  }])
  .name;

console.log('app.interceptors created');
